import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _slicedToArray from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import n from "../core/Error.js";
import { clamp as e, deg2rad as t, rad2deg as r, asinClamped as l } from "../core/mathUtils.js";
import { isNone as u, unwrap as o, isSome as a } from "../core/maybe.js";
import { throwIfAborted as s } from "../core/promiseUtils.js";
import { getMetersPerUnitForSR as i } from "../core/unitUtils.js";
import { i as c, a as f, t as p } from "../chunks/mat4.js";
import { g as h, b as m, f as d, n as M, l as R } from "../chunks/vec3.js";
import { c as j } from "../chunks/vec3f64.js";
import w from "./Extent.js";
import y from "./Multipoint.js";
import { p as g, i as E, l as x } from "../chunks/pe.js";
import I from "./Point.js";
import P from "./Polygon.js";
import T from "./Polyline.js";
import { SphericalECEFSpatialReference as C, WGS84ECEFSpatialReference as z, SphericalPCPFMars as F, SphericalPCPFMoon as S } from "./projectionEllipsoid.js";
import { copy as b } from "./support/aaBoundingRect.js";
import { earth as k, moon as v, mars as q } from "./support/Ellipsoid.js";
import { earthEllipsoidConstants as A } from "./support/geodesicConstants.js";
import U from "./support/GeographicTransformation.js";
import { equals as G, isValid as W, isWGS84 as Z, isWebMercator as _, isPlateCarree as B, isMars as K, isMoon as L } from "./support/spatialReferenceUtils.js";
import { getGeometryZScaler as N } from "./support/zscale.js";
var V = null,
    X = null,
    D = null,
    H = {};

function J() {
  return !!V && E();
}

function O(n) {
  return u(D) && (D = Promise.all([x(), import("../chunks/geometryEngineBase.js").then(function (n) {
    return n.g;
  }), import("./geometryAdapters/hydrated.js")])), D.then(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 3),
        e = _ref2[1],
        t = _ref2[2].hydratedAdapter;

    s(n), X = t, V = e.default, V._enableProjection(g);
  });
}

function Q(n, e) {
  var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  return Array.isArray(n) ? 0 === n.length ? [] : Y(X, n, n[0].spatialReference, e, t) : Y(X, [n], n.spatialReference, e, t)[0];
}

function Y(n, e, t, r) {
  var l = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  if (u(t) || u(r)) return e;
  if (ln(t, r, l)) return e.map(function (n) {
    return o(an(n, t, r));
  });

  if (u(l)) {
    var _n2 = U.cacheKey(t, r);

    void 0 !== H[_n2] ? l = H[_n2] : (l = $(t, r, null), u(l) && (l = new U()), H[_n2] = l);
  }

  if (u(V)) throw new en();
  return V._project(n, e, t, r, l);
}

function $(n, e) {
  var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  if (u(V)) throw new en();
  if (u(n) || u(e)) return null;

  var r = V._getTransformation(X, n, e, t, null == t ? void 0 : t.spatialReference);

  return null !== r ? U.fromGE(r) : null;
}

function nn(n, e) {
  var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  if (u(V)) throw new en();

  var r = V._getTransformationBySuitability(X, n, e, t, null == t ? void 0 : t.spatialReference);

  if (null !== r) {
    var _n3 = [];

    var _iterator = _createForOfIteratorHelper(r),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _e = _step.value;

        _n3.push(U.fromGE(_e));
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return _n3;
  }

  return [];
}

var en = /*#__PURE__*/function (_n4) {
  _inherits(en, _n4);

  var _super = _createSuper(en);

  function en() {
    _classCallCheck(this, en);

    return _super.call(this, "projection:not-loaded", "projection engine not fully loaded yet, please call load()");
  }

  return en;
}(n);

function tn() {
  V = null, X = null, D = null, H = {};
}

function rn(n, e) {
  try {
    var _t = Q(n, e);

    if (null == _t) return null;
    "xmin" in n && "xmin" in _t && (_t.zmin = n.zmin, _t.zmax = n.zmax);

    var _r = N(_t.type, n.spatialReference, e);

    return a(_r) && _r(_t), _t;
  } catch (t) {
    if (!(t instanceof en)) throw t;
    return null;
  }
}

function ln(n, e, t) {
  return !t && (!!G(n, e) || W(n) && W(e) && !!we(n, e, Ie));
}

function un(_x, _x2, _x3, _x4) {
  return _un.apply(this, arguments);
}

function _un() {
  _un = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(n, e, t, r) {
    var _iterator7, _step7, _step7$value, _l3, _u4, _o;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (J()) {
              _context.next = 23;
              break;
            }

            if (!Array.isArray(n)) {
              _context.next = 21;
              break;
            }

            _iterator7 = _createForOfIteratorHelper(n);
            _context.prev = 3;

            _iterator7.s();

          case 5:
            if ((_step7 = _iterator7.n()).done) {
              _context.next = 11;
              break;
            }

            _step7$value = _step7.value, _l3 = _step7$value.source, _u4 = _step7$value.dest, _o = _step7$value.geographicTransformation;

            if (ln(_l3, _u4, _o)) {
              _context.next = 9;
              break;
            }

            return _context.abrupt("return", O(r));

          case 9:
            _context.next = 5;
            break;

          case 11:
            _context.next = 16;
            break;

          case 13:
            _context.prev = 13;
            _context.t0 = _context["catch"](3);

            _iterator7.e(_context.t0);

          case 16:
            _context.prev = 16;

            _iterator7.f();

            return _context.finish(16);

          case 19:
            _context.next = 23;
            break;

          case 21:
            if (ln(n, e, t)) {
              _context.next = 23;
              break;
            }

            return _context.abrupt("return", O(r));

          case 23:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[3, 13, 16, 19]]);
  }));
  return _un.apply(this, arguments);
}

function on(n, e) {
  switch (we(n, e, Ie)) {
    case Zn:
      return "copy3";

    case oe:
      return "wgs84ToSphericalECEF";

    case Nn:
      return "wgs84ToWebMercator";

    case Dn:
      return "wgs84ToPlateCarree";

    case me:
      return "wgs84ToWGS84ECEF";

    case _n:
      return "webMercatorToWGS84";

    case Bn:
      return "webMercatorToSphericalECEF";

    case Kn:
      return "webMercatorToWGS84ECEF";

    case Jn:
      return "webMercatorToPlateCarree";

    case de:
      return "wgs84ECEFToWGS84";

    case Me:
      return "wgs84ECEFToSphericalECEF";

    case Re:
      return "wgs84ECEFToWebMercator";

    case ce:
      return "sphericalECEFToWGS84";

    case fe:
      return "sphericalECEFToWebMercator";

    case ie:
      return "sphericalMarsPCPFToMars2000";

    case se:
      return "sphericalMoonPCPFToMoon2000";

    case pe:
      return "sphericalECEFToWGS84ECEF";

    case ue:
      return "mars2000ToSphericalPCPF";

    case le:
      return "moon2000ToSphericalPCPF";

    default:
      return null;
  }
}

function an(n, e, t) {
  return n ? "x" in n ? cn(n, e, new I(), t, 0) : "xmin" in n ? jn(n, e, new w(), t, 0) : "rings" in n ? Mn(n, e, new P(), t, 0) : "paths" in n ? mn(n, e, new T(), t, 0) : "points" in n ? pn(n, e, new y(), t, 0) : null : null;
}

function sn(n, e) {
  var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : e.spatialReference;
  var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  return !u(t) && a(cn(n, n.spatialReference, e, t, r));
}

function cn(n, e, t, r, l) {
  be[0] = n.x, be[1] = n.y;
  var u = n.z;
  return be[2] = void 0 !== u ? u : l, Cn(be, e, 0, be, r, 0, 1) ? (t.x = be[0], t.y = be[1], t.spatialReference = r, void 0 === u ? (t.z = void 0, t.hasZ = !1) : (t.z = be[2], t.hasZ = !0), void 0 === n.m ? (t.m = void 0, t.hasM = !1) : (t.m = n.m, t.hasM = !0), t) : null;
}

function fn(n, e) {
  var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : e.spatialReference;
  var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  return !u(t) && a(pn(n, n.spatialReference, e, t, r));
}

function pn(n, e, t, r, l) {
  var u = n.points,
      o = n.hasZ,
      a = n.hasM,
      s = [],
      i = u.length,
      c = [];

  var _iterator2 = _createForOfIteratorHelper(u),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _f2 = _step2.value;
      c.push(_f2[0], _f2[1], o ? _f2[2] : l);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  if (!Cn(c, e, 0, c, r, 0, i)) return null;

  for (var _f = 0; _f < i; ++_f) {
    var _n5 = 3 * _f,
        _e2 = c[_n5],
        _t2 = c[_n5 + 1];

    o && a ? s.push([_e2, _t2, c[_n5 + 2], u[_f][3]]) : o ? s.push([_e2, _t2, c[_n5 + 2]]) : a ? s.push([_e2, _t2, u[_f][2]]) : s.push([_e2, _t2]);
  }

  return t.points = s, t.spatialReference = r, t.hasZ = o, t.hasM = a, t;
}

function hn(n, e) {
  var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : e.spatialReference;
  var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  return a(t) && a(mn(n, n.spatialReference, e, t, r));
}

function mn(n, e, t, r, l) {
  var u = n.paths,
      o = n.hasZ,
      a = n.hasM,
      s = [];
  return Fn(u, o, a, e, s, r, l) ? (t.paths = s, t.spatialReference = r, t.hasZ = o, t.hasM = a, t) : null;
}

function dn(n, e) {
  var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : e.spatialReference;
  var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  return a(t) && a(Mn(n, n.spatialReference, e, t, r));
}

function Mn(n, e, t, r, l) {
  var u = n.rings,
      o = n.hasZ,
      a = n.hasM,
      s = [];
  return Fn(u, o, a, e, s, r, l) ? (t.rings = s, t.spatialReference = r, t.hasZ = o, t.hasM = a, t) : null;
}

function Rn(n, e) {
  var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : e.spatialReference;
  var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  return a(t) && a(jn(n, n.spatialReference, e, t, r));
}

function jn(n, e, t, r, l) {
  var u = n.xmin,
      o = n.ymin,
      a = n.xmax,
      s = n.ymax,
      i = n.hasZ,
      c = n.hasM;
  if (!En(u, o, i ? n.zmin : l, e, be, r)) return null;
  t.xmin = be[0], t.ymin = be[1], i && (t.zmin = be[2]);
  return En(a, s, i ? n.zmax : l, e, be, r) ? (t.xmax = be[0], t.ymax = be[1], i && (t.zmax = be[2]), c && (t.mmin = n.mmin, t.mmax = n.mmax), t.spatialReference = r, t) : null;
}

function wn(n, e, t) {
  if (u(e) || u(t)) return null;
  var r = new I({
    spatialReference: t
  });
  return Cn(n, e, 0, be, t, 0, 1) ? (r.x = be[0], r.y = be[1], r.z = be[2], r) : null;
}

function yn(n, e, t) {
  return Cn(n, e, 0, be, t.spatialReference, 0, 1) ? (t.x = be[0], t.y = be[1], t.z = be[2], t) : null;
}

function gn(n, e, t) {
  var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  be[0] = n.x, be[1] = n.y;
  var l = n.z;
  return be[2] = void 0 !== l ? l : r, Cn(be, n.spatialReference, 0, e, t, 0, 1);
}

function En(n, e, t, r, l, u) {
  return ze[0] = n, ze[1] = e, ze[2] = t, Cn(ze, r, 0, l, u, 0, 1);
}

function xn(n, e, t, r) {
  return !(u(e) || u(r) || n.length < 2) && (2 === n.length && (ze[0] = n[0], ze[1] = n[1], ze[2] = 0, n = ze), Cn(n, e, 0, t, r, 0, 1));
}

function In(n, e) {
  be[0] = n.x, be[1] = n.y;
  var t = n.z;
  return be[2] = void 0 !== t ? t : 0, Pn(be, n.spatialReference, e);
}

function Pn(n, e, t) {
  return Tn(n, e, t);
}

function Tn(n, e, t) {
  if (u(e)) return !1;
  var r = Wn(e, Ee),
      l = je[r][6];
  return !u(l) && (l(n, 0, ze, 0), t !== ze && (t[0] = ze[0], t[1] = ze[1], t.length > 2 && (t[2] = ze[2])), !0);
}

function Cn(n, e, t, r, l, o) {
  var a = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 1;
  var s = we(e, l, Ie);
  if (u(s)) return !1;

  if (s === Zn) {
    if (n === r && t === o) return !0;

    var _e3 = t + 3 * a;

    for (var _l = t, _u = o; _l < _e3; _l++, _u++) {
      r[_u] = n[_l];
    }

    return !0;
  }

  var i = t + 3 * a;

  for (var _u2 = t, _c = o; _u2 < i; _u2 += 3, _c += 3) {
    s(n, _u2, r, _c);
  }

  return !0;
}

function zn(n, e, t, r, l) {
  h(be, n), m(ke, n, e), xn(be, t, be, l), xn(ke, t, ke, l), d(r, ke, be), M(r, r);
}

function Fn(n, e, t, r, l, u) {
  var o = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
  var a = new Array();

  var _iterator3 = _createForOfIteratorHelper(n),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var _i = _step3.value;

      var _iterator5 = _createForOfIteratorHelper(_i),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var _n6 = _step5.value;
          a.push(_n6[0], _n6[1], e ? _n6[2] : o);
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  if (!Cn(a, r, 0, a, u, 0, a.length / 3)) return !1;
  var s = 0;
  l.length = 0;

  var _iterator4 = _createForOfIteratorHelper(n),
      _step4;

  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var _i2 = _step4.value;

      var _n7 = new Array();

      var _iterator6 = _createForOfIteratorHelper(_i2),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var _r2 = _step6.value;
          e && t ? _n7.push([a[s++], a[s++], a[s++], _r2[3]]) : e ? _n7.push([a[s++], a[s++], a[s++]]) : t ? (_n7.push([a[s++], a[s++], _r2[2]]), s++) : (_n7.push([a[s++], a[s++]]), s++);
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }

      l.push(_n7);
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }

  return !0;
}

function Sn(n, e, t, r) {
  if (u(e) || u(r)) return !1;
  var l = ye(e, r, Pe);
  if (l.projector === Zn) return t[0] = n[0], t[1] = n[1], t[2] = n[2], t[3] = n[3], !0;
  if (u(l.projector)) return !1;
  var o = l.source,
      s = l.dest;

  if (3 === s.spatialReferenceId) {
    var _e4 = je[o.spatialReferenceId][2];
    return !u(_e4) && (_e4(n, 0, Fe, 0), Nn(Fe, 0, t, 0), t[3] = bn(Fe[1], n[2], n[3], k.radius), !0);
  }

  if (2 !== o.spatialReferenceId && 5 !== o.spatialReferenceId || 12 !== s.spatialReferenceId) l.projector(n, 0, t, 0), t[3] = n[3] * o.metersPerUnit / s.metersPerUnit;else {
    var _e5 = je[o.spatialReferenceId][1],
        _r3 = je[1][12];
    var _u3 = n[3];
    a(_e5) && a(_r3) && (_u3 = bn(n[1], n[2], n[3], k.radius)), l.projector(n, 0, t, 0), t[3] = _u3;
  }
  return !0;
}

function bn(n, e, t, r) {
  var l = Math.abs(Te * n) + Math.asin(t / (r + e));
  return l >= Math.PI / 2 ? Number.MAX_VALUE : t / Math.cos(l);
}

function kn(n, e, t, r) {
  return null != n && (G(e, r) ? (b(t, n), !0) : (ze[0] = n[0], ze[1] = n[1], ze[2] = 0, !!Cn(ze, e, 0, ze, r, 0, 1) && (t[0] = ze[0], t[1] = ze[1], ze[0] = n[2], ze[1] = n[3], ze[2] = 0, !!Cn(ze, e, 0, ze, r, 0, 1) && (t[2] = ze[0], t[3] = ze[1], !0))));
}

function vn(n, e, t, r) {
  if (u(e) || u(r)) return !1;
  var l = Wn(e, Ee),
      o = Wn(r, xe);
  if (l === o && 0 !== l || G(e, r)) return t[0] = 1, t[1] = 1, t[2] = 1, !0;

  if (1 === l) {
    var _e6 = R(n),
        _r4 = _e6 / Math.sqrt(n[0] * n[0] + n[1] * n[1]),
        _l2 = _e6 / k.radius;

    if (3 === o) return t[0] = _r4 * _l2, t[1] = _r4 * _l2, t[2] = 1, !0;

    if (2 === o || 5 === o) {
      var _n8 = 180 / (k.radius * Math.PI);

      return t[0] = _n8 * _r4 * _l2, t[1] = _n8 * _l2, t[2] = 1, !0;
    }
  } else if (12 === l && (2 === o || 5 === o)) return t[0] = Xn, t[1] = Xn, t[2] = 1, !0;

  return !1;
}

function qn(n, e, t, r) {
  if (u(n) || u(r)) return !1;
  var l = Wn(n, Ee),
      o = Wn(r, xe);
  if (l === o && !An(o) && (0 !== l || G(n, r))) return c(t), f(t, t, e), !0;

  if (An(o)) {
    var _n9 = je[l][11],
        _r5 = je[11][o];
    return !u(_n9) && !u(_r5) && (_n9(e, 0, Fe, 0), _r5(Fe, 0, Se, 0), Un(Te * Fe[0], Te * Fe[1], t), t[12] = Se[0], t[13] = Se[1], t[14] = Se[2], !0);
  }

  if (!(3 !== o && 12 !== o || 2 !== l && 1 !== l && 3 !== l)) {
    var _n10 = je[l][11],
        _r6 = je[11][o];
    return !u(_n10) && !u(_r6) && (_n10(e, 0, Fe, 0), _r6(Fe, 0, Se, 0), 1 === l ? Gn(Te * Fe[0], Te * Fe[1], t) : c(t), t[12] = Se[0], t[13] = Se[1], t[14] = Se[2], !0);
  }

  return !1;
}

function An(n) {
  return 1 === n || 7 === n || 9 === n;
}

function Un(n, e, t) {
  var r = Math.sin(n),
      l = Math.cos(n),
      u = Math.sin(e),
      o = Math.cos(e),
      a = t;
  return a[0] = -r, a[4] = -u * l, a[8] = o * l, a[12] = 0, a[1] = l, a[5] = -u * r, a[9] = o * r, a[13] = 0, a[2] = 0, a[6] = o, a[10] = u, a[14] = 0, a[3] = 0, a[7] = 0, a[11] = 0, a[15] = 1, a;
}

function Gn(n, e, t) {
  return Un(n, e, t), p(t, t), t;
}

function Wn(n, e) {
  return e.spatialReference === n ? e.spatialReferenceId : (e.spatialReference = n, "metersPerUnit" in e && (e.metersPerUnit = i(n, 1)), n.wkt === C.wkt ? e.spatialReferenceId = 1 : Z(n) ? e.spatialReferenceId = 2 : _(n) ? e.spatialReferenceId = 3 : B(n) ? e.spatialReferenceId = 12 : n.wkt === z.wkt ? e.spatialReferenceId = 4 : 4490 === n.wkid ? e.spatialReferenceId = 5 : n.wkt === F.wkt ? e.spatialReferenceId = 7 : n.wkt === S.wkt ? e.spatialReferenceId = 9 : K(n) ? e.spatialReferenceId = 8 : L(n) ? e.spatialReferenceId = 10 : e.spatialReferenceId = 0);
}

function Zn(n, e, t, r) {
  n !== t && (t[r++] = n[e++], t[r++] = n[e++], t[r] = n[e]);
}

function _n(n, e, t, r) {
  t[r++] = Ce * (n[e++] / k.radius), t[r++] = Ce * (Math.PI / 2 - 2 * Math.atan(Math.exp(-n[e++] / k.radius))), t[r] = n[e];
}

function Bn(n, e, t, r) {
  _n(n, e, t, r), oe(t, r, t, r);
}

function Kn(n, e, t, r) {
  _n(n, e, t, r), me(t, r, t, r);
}

function Ln(n, t, r, l, u) {
  var o = .4999999 * Math.PI,
      a = e(Te * n[t + 1], -o, o),
      s = Math.sin(a);
  r[l++] = Te * n[t] * u.radius, r[l++] = u.halfSemiMajorAxis * Math.log((1 + s) / (1 - s)), r[l] = n[t + 2];
}

function Nn(n, e, t, r) {
  Ln(n, e, t, r, k);
}

var Vn = k.radius * Math.PI / 180,
    Xn = 180 / (k.radius * Math.PI);

function Dn(n, e, t, r) {
  t[r] = n[e] * Vn, t[r + 1] = n[e + 1] * Vn, t[r + 2] = n[e + 2];
}

function Hn(n, e, t, r) {
  t[r] = n[e] * Xn, t[r + 1] = n[e + 1] * Xn, t[r + 2] = n[e + 2];
}

function Jn(n, e, t, r) {
  _n(n, e, t, r), Dn(t, r, t, r);
}

function On(n, e, t, r) {
  de(n, e, t, r), Dn(t, r, t, r);
}

function Qn(n, e, t, r) {
  ce(n, e, t, r), Dn(t, r, t, r);
}

function Yn(n, e, t, r) {
  Hn(n, e, t, r), oe(t, r, t, r);
}

function $n(n, e, t, r) {
  Hn(n, e, t, r), Nn(t, r, t, r);
}

function ne(n, e, t, r) {
  Hn(n, e, t, r), me(t, r, t, r);
}

function ee(n) {
  if (u(n)) return !1;
  var e = Wn(n, Ee);
  return !!je[e][6];
}

function te(n, e, t, r) {
  var l = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
  var u = r + l,
      o = Math.cos(t);
  n[0] = Math.cos(e) * o * u, n[1] = Math.sin(e) * o * u, n[2] = Math.sin(t) * u;
}

function re(n, e, t, r, l) {
  var u = l + n[e + 2],
      o = Te * n[e + 1],
      a = Te * n[e],
      s = Math.cos(o);
  t[r++] = Math.cos(a) * s * u, t[r++] = Math.sin(a) * s * u, t[r] = Math.sin(o) * u;
}

function le(n, e, t, r) {
  re(n, e, t, r, v.radius);
}

function ue(n, e, t, r) {
  re(n, e, t, r, q.radius);
}

function oe(n, e, t, r) {
  re(n, e, t, r, k.radius);
}

function ae(n, e, t, r, u) {
  var o = n[e],
      a = n[e + 1],
      s = n[e + 2],
      i = Math.sqrt(o * o + a * a + s * s),
      c = l(s / (0 === i ? 1 : i)),
      f = Math.atan2(a, o);
  t[r++] = Ce * f, t[r++] = Ce * c, t[r] = i - u;
}

function se(n, e, t, r) {
  ae(n, e, t, r, v.radius);
}

function ie(n, e, t, r) {
  ae(n, e, t, r, q.radius);
}

function ce(n, e, t, r) {
  ae(n, e, t, r, k.radius);
}

function fe(n, e, t, r) {
  ce(n, e, t, r), Nn(t, r, t, r);
}

function pe(n, e, t, r) {
  ce(n, e, t, r), me(t, r, t, r);
}

function he(n, e, t, r, l) {
  var u = Te * n[e],
      o = Te * n[e + 1],
      a = n[e + 2],
      s = Math.sin(o),
      i = Math.cos(o),
      c = l.radius / Math.sqrt(1 - l.eccentricitySquared * s * s);
  t[r++] = (c + a) * i * Math.cos(u), t[r++] = (c + a) * i * Math.sin(u), t[r++] = (c * (1 - l.eccentricitySquared) + a) * s;
}

function me(n, e, t, r) {
  he(n, e, t, r, k);
}

function de(n, e, t, r) {
  var l = A,
      u = n[e],
      o = n[e + 1],
      a = n[e + 2];
  var s, i, c, f, p, h, m, d, M, R, j, w, y, g, E, x, I, P, T, C, z;
  s = Math.abs(a), i = u * u + o * o, c = Math.sqrt(i), f = i + a * a, p = Math.sqrt(f), C = Math.atan2(o, u), h = a * a / f, m = i / f, g = l.a2 / p, E = l.a3 - l.a4 / p, m > .3 ? (d = s / p * (1 + m * (l.a1 + g + h * E) / p), T = Math.asin(d), R = d * d, M = Math.sqrt(1 - R)) : (M = c / p * (1 - h * (l.a5 - g - m * E) / p), T = Math.acos(M), R = 1 - M * M, d = Math.sqrt(R)), j = 1 - k.eccentricitySquared * R, w = k.radius / Math.sqrt(j), y = l.a6 * w, g = c - w * M, E = s - y * d, I = M * g + d * E, x = M * E - d * g, P = x / (y / j + I), T += P, z = I + x * P / 2, a < 0 && (T = -T), t[r++] = Ce * C, t[r++] = Ce * T, t[r] = z;
}

function Me(n, e, t, r) {
  de(n, e, t, r), oe(t, r, t, r);
}

function Re(n, e, t, r) {
  de(n, e, t, r), Nn(t, r, t, r);
}

var je = {
  2: {
    5: null,
    8: null,
    10: null,
    11: Zn,
    6: Zn,
    1: oe,
    7: null,
    9: null,
    0: null,
    3: Nn,
    12: Dn,
    2: Zn,
    4: me
  },
  5: {
    5: Zn,
    8: null,
    10: null,
    11: Zn,
    6: Zn,
    1: oe,
    7: null,
    9: null,
    0: null,
    3: null,
    12: Dn,
    2: null,
    4: me
  },
  8: {
    5: null,
    8: Zn,
    10: null,
    11: Zn,
    6: null,
    1: null,
    7: ue,
    9: null,
    0: null,
    3: null,
    12: null,
    2: null,
    4: null
  },
  10: {
    5: null,
    8: null,
    10: Zn,
    11: Zn,
    6: null,
    1: null,
    7: null,
    9: le,
    0: null,
    3: null,
    12: null,
    2: null,
    4: null
  },
  3: {
    5: null,
    8: null,
    10: null,
    11: _n,
    6: _n,
    1: Bn,
    7: null,
    9: null,
    0: null,
    3: Zn,
    12: Jn,
    2: _n,
    4: Kn
  },
  4: {
    5: de,
    8: null,
    10: null,
    11: de,
    6: de,
    1: Me,
    7: null,
    9: null,
    0: null,
    3: Re,
    12: On,
    2: de,
    4: Zn
  },
  1: {
    5: ce,
    8: null,
    10: null,
    11: ce,
    6: ce,
    1: Zn,
    7: null,
    9: null,
    0: null,
    3: fe,
    12: Qn,
    2: ce,
    4: pe
  },
  7: {
    5: null,
    8: ie,
    10: null,
    11: ie,
    6: null,
    1: null,
    7: Zn,
    9: null,
    0: null,
    3: null,
    12: null,
    2: null,
    4: null
  },
  9: {
    5: null,
    8: null,
    10: se,
    11: se,
    6: null,
    1: null,
    7: null,
    9: Zn,
    0: null,
    3: null,
    12: null,
    2: null,
    4: null
  },
  0: {
    5: null,
    8: null,
    10: null,
    11: null,
    6: null,
    1: null,
    7: null,
    9: null,
    0: Zn,
    3: null,
    12: null,
    2: null,
    4: null
  },
  11: {
    5: Zn,
    8: Zn,
    10: Zn,
    11: Zn,
    6: Zn,
    1: oe,
    7: ue,
    9: le,
    0: null,
    3: Nn,
    12: Dn,
    2: Zn,
    4: me
  },
  6: {
    5: null,
    8: null,
    10: null,
    11: Zn,
    6: Zn,
    1: oe,
    7: null,
    9: null,
    0: null,
    3: null,
    12: Dn,
    2: Zn,
    4: me
  },
  12: {
    5: Hn,
    8: null,
    10: null,
    11: Hn,
    6: Hn,
    1: Yn,
    7: null,
    9: null,
    0: null,
    3: $n,
    12: Zn,
    2: Hn,
    4: ne
  }
};

function we(n, e) {
  var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ge();
  return u(n) || u(e) ? null : ye(n, e, t).projector;
}

function ye(n, e, t) {
  if (u(n) || u(e) || t.source.spatialReference === n && t.dest.spatialReference === e) return t;
  var r = Wn(n, t.source),
      l = Wn(e, t.dest);
  return 0 === r && 0 === l ? G(n, e) ? t.projector = Zn : t.projector = null : t.projector = je[r][l], t;
}

function ge() {
  return {
    source: {
      spatialReference: null,
      spatialReferenceId: 0,
      metersPerUnit: 1
    },
    dest: {
      spatialReference: null,
      spatialReferenceId: 0,
      metersPerUnit: 1
    },
    projector: Zn
  };
}

var Ee = {
  spatialReference: null,
  spatialReferenceId: 0
},
    xe = {
  spatialReference: null,
  spatialReferenceId: 0
},
    Ie = ge(),
    Pe = ge(),
    Te = t(1),
    Ce = r(1),
    ze = j(),
    Fe = j(),
    Se = j(),
    be = j(),
    ke = j();
export { ee as canProjectToWGS84ComparableLonLat, ln as canProjectWithoutEngine, Un as computeENUToSphericalPCPFLocalRotation, Gn as computeSphericalPCPFToENULocalRotation, qn as computeTranslationToOriginAndRotation, on as getProjectorName, $ as getTransformation, nn as getTransformations, un as initializeProjection, J as isLoaded, O as load, vn as localLinearScaleFactors, te as lonLatToSphericalPCPF, Ln as lonLatToWebMercatorComparable, Q as project, kn as projectBoundingRect, Sn as projectBoundingSphere, Cn as projectBuffer, zn as projectDirection, Rn as projectExtent, Y as projectMany, fn as projectMultipoint, sn as projectPoint, gn as projectPointToVector, In as projectPointToWGS84ComparableLonLat, dn as projectPolygon, hn as projectPolyline, yn as projectVectorToDehydratedPoint, wn as projectVectorToPoint, xn as projectVectorToVector, Pn as projectVectorToWGS84ComparableLonLat, an as projectWithoutEngine, En as projectXYZToVector, ae as sphericalPCPFtoLonLatElevation, rn as tryProjectWithZConversion, tn as unload };